import { Component, Input } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { DialogContentBase, DialogRef, KENDO_DIALOGS } from "@progress/kendo-angular-dialog";
import { KENDO_BUTTONS } from "@progress/kendo-angular-buttons";
import { KENDO_INPUTS } from "@progress/kendo-angular-inputs";
import { KENDO_LABEL } from "@progress/kendo-angular-label";
import { PrimeNGConfig } from "primeng/api";

@Component({
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, KENDO_BUTTONS, KENDO_DIALOGS, KENDO_INPUTS, KENDO_LABEL],
    selector: "persist-model-dialog",
    template: `
        <kendo-dialog-titlebar (close)="onClose()">
            <div style="font-size: 18px; line-height: 1.3em;">
                <span>{{title}}</span>
            </div>
        </kendo-dialog-titlebar>

        <div style="padding: 1rem;">
            <form class="k-form" [formGroup]="formGroup">
                <kendo-formfield style="margin-bottom: 1rem;">
                    <kendo-label [for]="name" [text]="nameLabel"></kendo-label>
                    <kendo-textbox #name formControlName="name"></kendo-textbox>
                </kendo-formfield>
                <!--
                <kendo-formfield style="margin-bottom: 1rem;">
                    <kendo-label [for]="primary" [text]="primaryLabel"></kendo-label>
                    <input kendoCheckBox #primary type="checkbox" formControlName="primary"/>
                </kendo-formfield>
                 -->
                <kendo-formfield style="margin-bottom: 1rem;">
                    <kendo-label [for]="displayOrder" [text]="displayOrderLabel"></kendo-label>
                    <kendo-numerictextbox format="#" [decimals]="0" #displayOrder formControlName="displayOrder"></kendo-numerictextbox>
                </kendo-formfield>
            </form>
        </div>

        <kendo-dialog-actions layout="end">
            <button kendoButton (click)="onConfirmAction()" themeColor="primary" [disabled]="!formGroup.valid">{{saveLabel}}</button>
            <button kendoButton (click)="onCancelAction()">{{cancelLabel}}</button>
        </kendo-dialog-actions>
  `,
})
export class PersistModelDialogComponent extends DialogContentBase {
    public title: string;
    public saveLabel: string;
    public cancelLabel: string;
    public nameLabel: string;
    public primaryLabel: string;
    public displayOrderLabel: string;

    @Input() public id: number;
    @Input() public name: string;
    @Input() public primary: boolean;
    @Input() public displayOrder: number;

    public formGroup: FormGroup;

    constructor(dialogRef: DialogRef, private primengConfig: PrimeNGConfig, private formBuilder: FormBuilder) {
        super(dialogRef);
        this.saveLabel = this.primengConfig.getTranslation('common.save');
        this.cancelLabel = this.primengConfig.getTranslation('common.cancel');
        this.nameLabel = this.primengConfig.getTranslation('persistStateModel.name');
        this.primaryLabel = this.primengConfig.getTranslation('persistStateModel.primary');
        this.displayOrderLabel = this.primengConfig.getTranslation('persistStateModel.displayOrder');
    }

    public initialize(id: number, name: string, primary: boolean, displayOrder: number): void {
        this.title = this.primengConfig.getTranslation(id === 0 ? 'title.newView' : 'title.editView');

        this.formGroup = this.formBuilder.group({
            id: [id],
            name: [name, Validators.required],
            primary: [primary],
            displayOrder: [displayOrder],
        });
    }
    public onClose(): void {
        this.dialog.close({ text: "Cancel" });
    }

    public onCancelAction(): void {
        this.dialog.close({ text: "Cancel" });
    }

    public onConfirmAction(): void {
        this.dialog.close({ text: "Submit" });
    }
}
